var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.53125C0.25 6.80469 0.445312 7 0.71875 7H2.28125C2.51562 7 2.75 6.80469 2.75 6.53125V3.25H6.03125C6.26562 3.25 6.5 3.05469 6.5 2.78125V1.21875C6.5 0.984375 6.26562 0.75 6.03125 0.75H1.1875C0.640625 0.75 0.25 1.17969 0.25 1.6875V6.53125ZM11.5 1.21875V2.78125C11.5 3.05469 11.6953 3.25 11.9688 3.25H15.25V6.53125C15.25 6.80469 15.4453 7 15.7188 7H17.2812C17.5156 7 17.75 6.80469 17.75 6.53125V1.6875C17.75 1.17969 17.3203 0.75 16.8125 0.75H11.9688C11.6953 0.75 11.5 0.984375 11.5 1.21875ZM17.2812 12H15.7188C15.4453 12 15.25 12.2344 15.25 12.4688V15.75H11.9688C11.6953 15.75 11.5 15.9844 11.5 16.2188V17.7812C11.5 18.0547 11.6953 18.25 11.9688 18.25H16.8125C17.3203 18.25 17.75 17.8594 17.75 17.3125V12.4688C17.75 12.2344 17.5156 12 17.2812 12ZM6.5 17.7812V16.2188C6.5 15.9844 6.26562 15.75 6.03125 15.75H2.75V12.4688C2.75 12.2344 2.51562 12 2.28125 12H0.71875C0.445312 12 0.25 12.2344 0.25 12.4688V17.3125C0.25 17.8594 0.640625 18.25 1.1875 18.25H6.03125C6.26562 18.25 6.5 18.0547 6.5 17.7812Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.1c0285b1b3b3b06373d9199eed52bedf.svg";
export { ForwardRef as ReactComponent };